<div id="fab-dismiss" 
     *ngIf="fabTogglerState==='active'" 
     (click)="onToggleFab()">
</div>
<div class="fab-container">
    <button mat-fab class="fab-toggler"
            (click)="onToggleFab()">
      <i class="material-icons" [@fabToggler]="{value: fabTogglerState}">{{icon}}</i>
    </button>
    <div [@speedDialStagger]="displayButtons.length">
      <button *ngFor="let btn of displayButtons"
              mat-fab extended
              class="fab-secondary"
              color="secondary" [routerLink]="btn.route ? btn.route : './'">
        <i class="material-icons">{{btn.icon}}</i>{{btn.label ? btn.label : ''}}
      </button>
    </div>
  </div>